import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import 'rxjs/add/operator/catch';



@Injectable()
export class DbService {
    private appURL: string = environment.apiUrl;
    private uploadUrl: string = environment.uploadUrl;
    constructor(private http: HttpClient) { }
    /*
    * Applicant Profile functions
    */
    // Save Applicant Profile
    saveApp(app) {
        return this.http.post(this.appURL + 'saveApplicantProfile', JSON.stringify(app));
    }
    saveAmbition(amb) {
        return this.http.post(this.appURL + 'saveApplicantAmbition', JSON.stringify(amb));
    }
    saveAintial(ais) {
        return this.http.post(this.appURL + 'saveApplicantAssessment', JSON.stringify(ais));
    }
    saveAevalu(ael) {
        return this.http.post(this.appURL + 'saveApplicantProfile', JSON.stringify(ael));
    }
    saveAhiring(ahr) {
        return this.http.post(this.appURL + 'saveApplicantProfile', JSON.stringify(ahr));
    }
    saveApplicantEvaluation(evalu) {
        return this.http.post(this.appURL + 'saveApplicantEvaluation', JSON.stringify(evalu));
    }
    getApp(appId, pro_id, currentUser) {
        return this.http.post(this.appURL + 'getApplicantDetails', JSON.stringify({ 'id': appId, pro_id: pro_id, currentUser: currentUser }));
    }
    getComp(compId) {
        return this.http.post(this.appURL + 'getCompDetails', JSON.stringify({ 'id': compId }));
    }
    getApplicantShortDetails(appId) {
        return this.http.post(this.appURL + 'getApplicantShortDetails', JSON.stringify({ 'id': appId }));
    }
    getAmbition(appId) {
        return this.http.post(this.appURL + 'getApplicantAmbitionDetail', JSON.stringify({ 'applicant_id': appId }));
    }
    getAintial(appId) {
        return this.http.post(this.appURL + 'getApplicantAssessmentDetails', JSON.stringify({ 'applicant_id': appId }));
    }
    getAevalu(appId) {
        return this.http.post(this.appURL + 'getApplicantEvaluationDetails', JSON.stringify({ 'applicant_id': appId }));
    }
    getApplicantEvaluationDetails(appId) {
        return this.http.post(this.appURL + 'getApplicantEvaluationDetails', JSON.stringify({ 'applicant_id': appId }));
    }
    // Report function start here
    getAppTierLevel(tier, id, ref_src, asc, name) {
        return this.http.post(this.appURL + 'getApplicantListReport', JSON.stringify({ 'tier': tier, id: id, ref_src: ref_src, asc: asc, name: name }));
    }

    getAppTransReport() {
        return this.http.get(this.appURL + 'getAppTransReport');
    }

    sort(aaa) {
        return this.http.post(this.appURL + 'sort', JSON.stringify({ 'aaa': aaa }));
    }

    getAppTierLevel1(tier, id, currentUser, ref_src) {
        return this.http.post(this.appURL + 'getApplicantListReport1', JSON.stringify({ 'tier': tier, id: id, currentUser: currentUser, ref_src: ref_src }));
    }

    getApplicantStrenthWeakReport(tier, id, ref_src) {
        return this.http.post(this.appURL + 'getApplicantStrenthWeakReport', JSON.stringify({ 'tier': tier, id: id, ref_src: ref_src }));
    }
    getApplicantHiredEmpByWardReport(tier, currentUser, id, ref_src) {
        return this.http.post(this.appURL + 'getApplicantHiredEmpByWardReport', JSON.stringify({ 'tier': tier, currentUser: currentUser, id: id, ref_src: ref_src }));
    }
    getApplicantWards(tier, id) {
        return this.http.post(this.appURL + 'getApplicantWards', JSON.stringify({ 'tier': tier, id: id }));
    }
    hireApplicant(hire) {
        return this.http.post(this.appURL + 'saveApplicantHired', JSON.stringify(hire));
    }
    getApplicantHired(a) {
        return this.http.post(this.appURL + 'getApplicantHired', JSON.stringify({ appId: a }));
    }
    terminateApp(app) {
        return this.http.post(this.appURL + 'saveApplicantTerminate', JSON.stringify(app));
    }
    // company services starts here
    saveCompanyProfile(comp) {
        return this.http.post(this.appURL + 'saveCompanyProfile', JSON.stringify(comp));
    }
    companyAssessmentSave(c) {
        return this.http.post(this.appURL + 'companyAssessmentSave', JSON.stringify(c));
    }
    companyEvaluationSave(c) {
        return this.http.post(this.appURL + 'companyEvaluationSave', JSON.stringify(c));
    }
    getCompanyAssessmentDetails(c) {
        return this.http.post(this.appURL + 'getCompanyAssessmentDetails', JSON.stringify({ id: c }));
    }
    getCompanyEvaluationDetails(c) {
        return this.http.post(this.appURL + 'getCompanyEvaluationDetails', JSON.stringify({ compId: c }));
    }
    getUploadDetilsByCompId(c) {
        return this.http.post(this.appURL + 'getUploadDetilsByCompId', JSON.stringify({ compId: c }));
    }
    hireCompany(hire) {
        return this.http.post(this.appURL + 'saveCompanyHired', JSON.stringify(hire));
    }
    getCompanyHired(a) {
        return this.http.post(this.appURL + 'getCompanyHired', JSON.stringify({ compId: a }));
    }
    terminateComp(app) {
        return this.http.post(this.appURL + 'saveCompanyTerminate', JSON.stringify(app));
    }
    transferApp(app, currUser, project_id) {
        return this.http.post(this.appURL + 'transferApp', JSON.stringify({ appId: app, currUser: currUser, project_id: project_id }));
    }

    transferApp_detail(app, currUser) {
        return this.http.post(this.appURL + 'transferApp_detail', JSON.stringify({ appId: app, currUser: currUser }));
    }

    transferApp_compliance_update(app, currUser) {
        return this.http.post(this.appURL + 'transferApp_compliance_update', JSON.stringify({ appId: app, currUser: currUser }));
    }



    // upload service
    uploadCertificate(formData, sname, company_users_id) {
        return this.http.post(this.uploadUrl + 'upload1.php?sname='
            + sname + '&company_users_id=' + company_users_id, formData);
    }

    /*-----------------------------------------------*/
    getEmployeelist() {
        return this.http.get(this.appURL + 'saveApplicantProfile');
    }

    getEmployeeslist() {
        return this.http.get(this.appURL + 'getContractorNames');
    }

    getcompanySearch(id) {
        return this.http.post(this.appURL + 'getContractorProfileSearch', JSON.stringify({ id: id }));
    }

    updateCertificate(certList, currOrg, currUser) {
        return this.http.post(this.appURL + 'updateCertificate',
            JSON.stringify({ certList: certList, currOrg: currOrg, currUser: currUser }));
    }

    getConEmpList(contId) {
        return this.http.post(this.appURL + 'getConEmpList', JSON.stringify({ contId: contId }));
    }

    uploadCertificate1(formData, certId, contId, cId) {
        return this.http.post(this.uploadUrl + 'upload.php?page=contractor&certId=' + certId
            + '&contId=' + contId + '&cId=' + cId, formData);
    }

    uploadResume(formData, empId, currentUser, uploadtype) {
        return this.http.post(this.uploadUrl + 'upload.php?page=employee&empId=' + empId + '&currentUser='
            + currentUser + '&uploadtype=' + uploadtype, formData);
    }

    uploadproof(formData, appId, secId, currentUser, uploadtype) {
        return this.http.post(this.uploadUrl + 'uploadsec3.php?page=sec3&secId=' + secId + '&appId='
            + appId + '&currentUser=' + currentUser + '&uploadtype=' + uploadtype, formData);
    }

    saveEmployee(emp) {
        return this.http.post(this.appURL + 'candidateSave', JSON.stringify({ emp: emp }));
    }
    getappid(pro_id) {
        return this.http.post(this.appURL + 'getappid', JSON.stringify({ pro_id: pro_id }));
    }

    lowertierSave(subCont, contId) {
        return this.http.post(this.appURL + 'saveLowertier', JSON.stringify({ subCont: subCont, contId: contId }));
    }

    uploadFile(formData: any) {
        const headers = new HttpHeaders()
            // .set('Access-Control-Allow-Origin', `*`)
            // .set('Access-Control-Request-Headers', `Content-type,X-Requested-With,Origin,accept`)
            .set('Content-Type', `multipart/form-data`);
        return this.http.post(this.uploadUrl + 'upload.php', formData, { headers }).subscribe();
    }

    movePrevious(subcont, contId) {
        return this.http.post(this.appURL + 'subContractorPrve', JSON.stringify({ subcont: subcont, contId: contId }));
    }

    moveNext(subcont, contId) {
        return this.http.post(this.appURL + 'subContractorNext', JSON.stringify({ subcont: subcont, contId: contId }));
    }

    deleteCertificate(certId, cont) {
        return this.http.post(this.appURL + 'deleteCertificate', JSON.stringify({ certId: certId, cont: cont }));
    }

    getOrgId(currentOrg) {
        return this.http.post(this.appURL + 'getOrgId', JSON.stringify({ currentOrg: currentOrg }));
    }
    Objtodate(obj) {
        return obj.month + '/' + obj.day + '/' + obj.year;
    }

    getSubContractor(contId) {
        return this.http.post(this.appURL + 'getSubContractor', JSON.stringify({ contId: contId }));
    }

    getBilling(subContId) {
        return this.http.post(this.appURL + 'getBilling', JSON.stringify({ subContId: subContId }));
    }


    saveSec3Applicant(applicant, empid) {
        return this.http.post(this.appURL + 'saveSec3Applicant', JSON.stringify({ applicant: applicant, empid: empid }));
    }

    getSec3Applicant(empid) {
        return this.http.post(this.appURL + 'getSec3Applicant', JSON.stringify({ empid: empid }));
    }

    hireApplicant1(hire) {
        return this.http.post(this.appURL + 'hireApplicant', JSON.stringify({ hire: hire }));
    }
    saveExpenditure(expen, currOrg) {
        return this.http.post(this.appURL + 'saveExpenditure', JSON.stringify({ expen: expen, currOrg: currOrg }));
    }

    deleteExpenPayment(id) {
        return this.http.post(this.appURL + 'deleteExpenPayment', JSON.stringify({ id: id }));
    }
    deleteExpenBilling(id) {
        return this.http.post(this.appURL + 'deleteExpenBilling', JSON.stringify({ id: id }));
    }
    saveworkinghours(workinghours, month, currentOrg) {
        return this.http.post(this.appURL + 'saveworkinghours',
            JSON.stringify({ workinghours: workinghours, month: month, currentOrg: currentOrg }));
    }
    getCurrworkinghours(month, currentOrg) {
        return this.http.post(this.appURL + 'getCurrworkinghours', JSON.stringify({ month: month, currentOrg: currentOrg }));
    }
    getCertificate(currOrg) {
        return this.http.post(this.appURL + 'getCertificate', JSON.stringify({ currOrg: currOrg }));
    }
    getCurrentDate() {
        const dateObj = new Date();
        const month = dateObj.getUTCMonth() + 1;
        const day = dateObj.getUTCDate();
        const year = dateObj.getUTCFullYear();
        return { date: { year: year, month: month, day: day } };
    }
    getBlankDate() {
        return { date: { year: null, month: null, day: null } };
    }
    terminateEmp(hire_id, termDate) {
        return this.http.post(this.appURL + 'terminated', JSON.stringify({ hire_id: hire_id, termDate: termDate }));
    }
    getCurrexpenditure(month, contId) {
        return this.http.post(this.appURL + 'getCurrexpenditure', JSON.stringify({ month: month, contId: contId }));
    }
    getEmployeeReports(contId, dates) {
        return this.http.post(this.appURL + 'getEmployeeReports', JSON.stringify({ dates: dates, contId: contId }));
    }
    getContractsReports(contId, dates) {
        return this.http.post(this.appURL + 'getContractsReports', JSON.stringify({ dates: dates, contId: contId }));
    }
    getCompanyListReport() {
        return this.http.get(this.appURL + 'getCompanyListReport');
    }
    getCompanyAvailableContractReport() {
        return this.http.get(this.appURL + 'getCompanyAvailableContractReport');
    }
    getCompanyContractValueReport() {
        return this.http.get(this.appURL + 'getCompanyContractValueReport');
    }
    getDeleteUploadById(id) {
        return this.http.post(this.appURL + 'getDeleteUploadById', JSON.stringify({ id: id }));
    }

    getEmpPrevNextList(empId, pre_nxt, currentUser, currentOrg, pro_id) {
        return this.http.post(this.appURL + 'getEmpPrevNextList',
            JSON.stringify({ emp_id: empId, pre_nxt: pre_nxt, currentUser: currentUser, currentOrg: currentOrg, pro_id: pro_id }));
    }

    getEmpPrevNextList_pcc_status(empId, pre_nxt, currentUser, currentOrg, pro_id) {
        return this.http.post(this.appURL + 'getEmpPrevNextList_pcc_status',
            JSON.stringify({ emp_id: empId, pre_nxt: pre_nxt, currentUser: currentUser, currentOrg: currentOrg, pro_id: pro_id }));
    }

    getcase_mgmnt(appId, pro_id, currentUser, currentOrg) {
        return this.http.post(this.appURL + 'getcase_mgmnt', JSON.stringify({ 'id': appId, pro_id: pro_id, currentUser: currentUser, currentOrg: currentOrg }));
    }

    getcase_mgmnt1(appId, pro_id, currentUser, currentOrg) {
        return this.http.post(this.appURL + 'getcase_mgmnt1', JSON.stringify({ 'id': appId, pro_id: pro_id, currentUser: currentUser, currentOrg: currentOrg }));
    }

    save_case_mgmnt(data, pro_id, currentUser, currentOrg) {
        return this.http.post(this.appURL + 'save_case_mgmnt', JSON.stringify({ data: data, pro_id: pro_id, currentUser: currentUser, currentOrg: currentOrg }));
    }

    get_firebase_data(currentUser, val) {
        return this.http.post(this.appURL + 'get_firebase_data', JSON.stringify({ currentUser: currentUser, val: val }));
    }

    transfer_firebase_data(id, addFid, currentUser) {
        return this.http.post(this.appURL + 'transfer_firebase_data', JSON.stringify({ id: id, addFid: addFid, currentUser: currentUser }));
    }

    save_firebase_data(data) {
        return this.http.post(this.appURL + 'save_firebase_data', JSON.stringify({ 'data': data }));
    }

}



// WEBPACK FOOTER //
// ./src/app/services/db.services.ts